<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-sm-3">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              name="searchTerm"
              placeholder="{{ 'lblSearch' | translate }}"
              [(ngModel)]="pService.searchTerm"
              autocomplete="off"
            />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" (click)="getUserClockInOutList()">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button
            type="button"
            class="btn btn-primary"
            (click)="onAdvanceSearch()"
            aria-label="Center Align"
          >
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <div
            class="searchbox card fix rt"
            *ngIf="requestModel.isAdvanceSearch"
          >
            <div class="form-row mt-3 mb-2">
              <div class="col-12">
                <label translate>lblStampIn</label>
                <div class="date">
                  <my-date-range-picker
                    name="BookedDate"
                    [options]="myDateRangePickerOptions"
                    [(ngModel)]="stampInOut"
                  ></my-date-range-picker>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col text-right">
                <button
                  type="submit"
                  (click)="AdvanceSearchSubmit()"
                  class="btn btn-primary mr-sm-2"
                  translate
                >
                  lblApply
                </button>
                <button
                  (click)="onReset()"
                  class="btn btn-outline-tertiary mr-sm-2"
                  translate
                >
                  lblReset
                </button>
                <button
                  (click)="onClose()"
                  class="btn btn-outline-tertiary"
                  translate
                >
                  lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-lg-3 col-md-6 col-sm-8"
      *ngIf="locationCodeList && locationCodeList.length > 0"
    >
      <div class="input-group">
        <ng-multiselect-dropdown
          style="width: 100%"
          [settings]="dropdownSettingForLocation"
          [data]="locationCodeList"
          placeholder="{{ 'lblSelectLocation' | translate }}"
          [(ngModel)]="selectedLocation"
          (ngModelChange)="onLocationSelection()"
        >
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div
      class="col-lg-3 col-md-6 col-sm-8"
      *ngIf="userList && userList.length > 0"
    >
      <div class="input-group">
        <ng-multiselect-dropdown
          style="width: 100%"
          [settings]="dropdownSettings"
          [data]="filterUserList"
          placeholder="{{ 'lblSelectUser' | translate }}"
          [(ngModel)]="selectedUsers"
          (ngModelChange)="onUserSelected()"
        >
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div
      class="col-auto ml-auto"
      *ngIf="userRoleRightsDetails.canAdd && isAddUserClockInOut"
    >
      <button
        type="button"
        (click)="onAdd()"
        type="reset"
        class="add-button btn btn-primary"
        aria-label="Center Align"
        translate
      >
      lblAddUserStampInOut
      </button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblUserClockInOut</h4>
        </div>
        <div class="table-responsive">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th
                  scope="col"
                  sortable="name"
                  (sort)="onSort($event)"
                  translate
                >
                  lblName
                </th>
                <th
                  scope="col"
                  sortable="role"
                  (sort)="onSort($event)"
                  translate
                >
                  lblRole
                </th>
                <th
                  scope="col"
                  sortable="stampIn"
                  (sort)="onSort($event)"
                  translate
                >
                  lblStampIn
                </th>
                <th
                  scope="col"
                  sortable="stampOut"
                  (sort)="onSort($event)"
                  translate
                >
                  lblStampOut
                </th>
                <th
                  scope="col"
                  sortable="locationName"
                  (sort)="onSort($event)"
                  translate
                >
                  lblLocationName
                </th>
                <th
                  scope="col"
                  sortable="comment"
                  (sort)="onSort($event)"
                  translate
                >
                  lblComment
                </th>
                <th
                  style="width: 120px"
                  scope="col"
                  class="text-center"
                  translate
                >
                  lblAction
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngIf="userClockInOutList?.length > 0; else load_else"
              >
                <tr
                  *ngFor="let clockInOut of userClockInOutList; let i = index"
                >
                  <td>{{ clockInOut.rowNumber }}</td>
                  <td>
                    <ngb-highlight
                      [result]="clockInOut.name"
                      [term]="pService.searchTerm"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="clockInOut.role"
                      [term]="pService.searchTerm"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="clockInOut.stampIn | date : 'short'"
                      [term]="pService.searchTerm"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="clockInOut.stampOut | date : 'short'"
                      [term]="pService.searchTerm"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="clockInOut.locationName"
                      [term]="pService.searchTerm"
                    ></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight
                      [result]="clockInOut.comment"
                      [term]="pService.searchTerm"
                    ></ngb-highlight>
                  </td>
                  <td class="nowrap text-center">
                    <a
                      class="btn btn-ico"
                      ngbTooltip="{{ 'lblEdit' | translate }}"
                      tooltipClass="custom-revert"
                      (click)="onEdit(clockInOut.id)"
                      *ngIf="userRoleRightsDetails.canEdit"
                      [class.disabled]="!clockInOut.stampOut && (clockInOut.stampIn | date:'yyyy-MM-dd') == (todayDate | date:'yyyy-MM-dd')"
                    >
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span
                      class="ico-div"
                      *ngIf="userRoleRightsDetails.canDelete"
                    ></span>
                    <a
                      class="btn btn-ico"
                      ngbTooltip="{{ 'lblDelete' | translate }}"
                      tooltipClass="custom-revert"
                      (click)="onDelete(clockInOut.id)"
                      *ngIf="userRoleRightsDetails.canDelete"
                      [class.disabled]="!clockInOut.stampOut && (clockInOut.stampIn | date:'yyyy-MM-dd') == (todayDate | date:'yyyy-MM-dd')"
                    >
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination
                [collectionSize]="pService.total$ | async"
                [(page)]="pService.page"
                [pageSize]="pService.pageSize"
                [maxSize]="3"
              >
              </ngb-pagination>
              <select
                class="custom-select mx-2"
                style="width: auto"
                name="pageSize"
                [(ngModel)]="pService.pageSize"
              >
                <option
                  *ngFor="let item of pService.pageItemsArray"
                  [ngValue]="item.values"
                  translate
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div
              class="d-flex justify-content-between p-2 font17 fontbold"
              style="margin: auto 0"
            >
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{
                pService.total$ | async
              }}&nbsp;<span class="font17 fontnormal" translate
                >lblResults</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- new theme implementation ends -->
